import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axios from "axios";
import { BASE_URL } from "../config";
import { ProgramDetailResponse } from "../interfaces/Program";
import { toast } from "react-toastify";

interface ProgramState {
  loading: boolean;
  user: any | null;
  error: string | null;
  isLoggedIn: boolean;
  data: Programs[] | null;
  data1: ProgramDetailResponse | null;
}

interface FetchProgramsParams {
  search?: string;
  sortField?: string;
  sort?: string;
  limit?: number;
  page?: number;
}

const initialState: ProgramState = {
  loading: false,
  user: null,
  error: null,
  isLoggedIn: false,
  data: null,
  data1: null,
};
interface PublishProgram {
  programId: string;
  publish: boolean;
}

interface Programs {
  id: string;
  bookedSlots:number;
  title: string;
  cost: string;
  startDate: string;
  startTime: number;
  endTime: number;
  totalCounsellings: number;
  maxParticipants: number;
  zoomLink: string;
  description: string;
  icon: string;
  slug: string;
  publish: boolean;
  healthCondition: string;
}

interface ParsedData {  
    accessToken?: string;
}

export const fetchProgramsAll = createAsyncThunk(
  "user/fetchProgramsAll",
  async (params: any, thunkAPI) => {
    try {

      const queryString = new URLSearchParams(params).toString();
      const response = await fetch(`${BASE_URL}/api/v1/patients/programs?${queryString}`); // Replace with your API endpoint
      const result = await response.json();
      return result.data.programs;
    } catch (error: any) {
      // Handle fetch or parsing error
      return thunkAPI.rejectWithValue(`Fetch failed: ${error.message}`);
    }
  }
);

export const fetchProgramsFilter = createAsyncThunk(
  "user/fetchProgramsFilter",
  async ({ programSlug, limit }: { programSlug: string; limit?: number }, thunkAPI) => {
    try {
      const response = await fetch(`${BASE_URL}/api/v1/patients/programs/latest?slug=${programSlug}&limit=${limit}`, {
        method: 'GET', // or 'GET' depending on your API
        headers: {
          'Content-Type': 'application/json',
          // Add any other headers as needed
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      
      const result = await response.json();
      return result.data.programs;
    } catch (error: any) {
      // Handle fetch or parsing error
      return thunkAPI.rejectWithValue(`Fetch failed: ${error.message}`);
    }
  }
);

export const fetchDataProgramDetails = createAsyncThunk(
  "user/fetchDataProgramDetails",
  async (programSlug: string, thunkAPI) => {
    try {
      const responseData = localStorage.getItem("loginData");

      if (!responseData) {
         
         console.log("Access token found in the response.");
         const response = await fetch(
           `${BASE_URL}/api/v1/patients/programs/${programSlug}`
         );
 
         localStorage.setItem('SetSlug', programSlug);
 
         if (!response.ok) {
           throw new Error("Failed to fetch program details");
         }
         const result = await response.json();
         return result.data.programs;
      }else{
        const parsedData: ParsedData = JSON.parse(responseData);
      const accessToken = parsedData?.accessToken;
      const Slugdata = localStorage.getItem("SetSlug");
      if (accessToken) {
        console.log("Access token not found in the response.");
        //return {}; // or any default value if needed
        const response = await fetch(
          `${BASE_URL}/api/v1/patients/programs/${programSlug}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
         if (!response.ok) {
           throw new Error("Failed to fetch program details");
         }
        const result = await response.json(); 
        return result.data.programs;
      }

      }
     
    } catch (error: any) {
      // Handle fetch or parsing error
      return thunkAPI.rejectWithValue(`Fetch failed: ${error.message}`);
    }
  }
);

export const fetchPrograms = createAsyncThunk(
  "user/fetchPrograms",
  async (params: any, thunkAPI) => {
    try {
      const responseData = localStorage.getItem("loginData");

      if (!responseData) {
        console.error("Response data is null.");
        return {}; // or any default value if needed
      }

      const parsedData: ParsedData = JSON.parse(responseData);
      const accessToken = parsedData?.accessToken;

      if (!accessToken) {
        console.error("Access token not found in the response.");
        return {}; // or any default value if needed
      }

      const queryString = new URLSearchParams(params).toString();

      const response = await fetch(
        `${BASE_URL}/api/v1/programs?${queryString}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            // Add other headers if needed
          },
        }
      );
      try {
        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error parsing response data:", error);
      }

      const jsonData = await response.json();
      return jsonData.data;
    } catch (error: any) {
      console.error("Error:", error.message);
      return thunkAPI.rejectWithValue(`Fetch failed: ${error.message}`);
    }
  }
);

export const deleteProgram = createAsyncThunk(
  "user/deleteProgram",
  async (programId: string, { getState, rejectWithValue }) => {
    try {
      const responseData = localStorage.getItem("loginData");

      if (responseData !== null) {
        const parsedData = JSON.parse(responseData);

        // Assuming your JSON structure matches the previous example
        const accessToken = parsedData?.accessToken;

        if (!accessToken) {
          throw new Error("Access token not found");
        }

        // Make API request to delete health condition
        const response = await axios.delete(
          `${BASE_URL}/api/v1/programs/${programId}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              // Add other headers if needed
            },
          }
        );
      }
    } catch (error: any) {
      // Return the error using rejectWithValue
      return rejectWithValue(error.message);
    }
  }
);
export const publishProgram = createAsyncThunk(
  "user/publishProgram",
  async (programData: PublishProgram, { getState, rejectWithValue }) => {
    try {
      const responseData = localStorage.getItem("loginData");

      if (responseData !== null) {
        const parsedData = JSON.parse(responseData);

        // Assuming your JSON structure matches the previous example
        const accessToken = parsedData?.accessToken;

        if (!accessToken) {
          throw new Error("Access token not found");
        }

        // Make API request to delete health condition
        const response= await axios.put(
          `${BASE_URL}/api/v1/programs/publish/${programData.programId}`,
          { publish: programData.publish },
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        console.log(response);
        toast.success(response.data.message);  
        
      }
    } catch (error: any) {      
      // Return the error using rejectWithValue
      toast("The publication was unsuccessful. Kindly complete all information needed");  
      return rejectWithValue(error.message);
    }
  }
);

const programSlice = createSlice({
  name: "programs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDataProgramDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDataProgramDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.data1 = action.payload;
      })
      .addCase(fetchDataProgramDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "An error occurred";
      })    
      .addCase(fetchProgramsFilter.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchProgramsFilter.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchProgramsFilter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "An error occurred";
      }).addCase(fetchProgramsAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchProgramsAll.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchProgramsAll.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "An error occurred";
      })
      .addCase(fetchPrograms.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPrograms.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchPrograms.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "An error occurred";
      })
      .addCase(deleteProgram.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteProgram.fulfilled, (state, action) => {
        state.loading = false;

        // Ensure that state.data is an array before filtering
        if (Array.isArray(state.data)) {
          // Remove the deleted health condition from the data array
          const deletedId = action.payload;
          state.data = state.data.filter(
            (Programs) => Programs.id !== deletedId
          );
        }
      })
      .addCase(deleteProgram.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default programSlice.reducer;
